import { create } from 'zustand';
import { EstablishPageType, AccountEstablishRequestParam } from 'views/utils/accountEstablish';
import { ButtonProps, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { useGetAddressInfoQuery, useGetBrokerMasterQuery } from 'views/utils/graphql/graphql';

/*--------------
  口座開設
  --------------*/
//入力データ管理
type EstablishStore = {
  param: AccountEstablishRequestParam;
  add: (data: AccountEstablishRequestParam) => void;
  clear: () => void;
};

export const useEstablishStore = create<EstablishStore>((set) => ({
  param: {} as AccountEstablishRequestParam,
  add: (data: AccountEstablishRequestParam) =>
    // 前のデータは残してセットしたい
    set((state) => ({ param: { ...state.param, ...data } })),
  clear: () => set({ param: {} as AccountEstablishRequestParam }),
}));

//画面遷移管理
type nowEstablishPageTypeStore = {
  nowEstablishPageType: EstablishPageType;
  setNowEstablishPageType: (navType: EstablishPageType) => void;
  reset: () => void;
};

export const useNowEstablishPageTypeStore = create<nowEstablishPageTypeStore>((set) => ({
  nowEstablishPageType: EstablishPageType.AddvanceQuestion,
  setNowEstablishPageType: (navType: EstablishPageType) => set((state) => ({ nowEstablishPageType: navType })),
  reset: () => set({ nowEstablishPageType: EstablishPageType.AddvanceQuestion }),
}));

type IsPrevPageConfirmStore = {
  isPrevPageConfirm: boolean;
  setIsPrevPageConfirm: (b: boolean) => void;
};
export const useIsPrevPageConfirmStore = create<IsPrevPageConfirmStore>((set) => ({
  isPrevPageConfirm: false,
  setIsPrevPageConfirm: (b: boolean) => set(() => ({ isPrevPageConfirm: b })),
}));

export enum TransitionBtn {
  OPEN_APPLY,
  UPDATE_APPLY,
  CONFIRM,
  NEXT,
  PREV,
  SEARCH_ADDRESS,
}
export const getBtnProps = (transitionBtn: TransitionBtn, cb?: () => void): ButtonProps => {
  switch (transitionBtn) {
    case TransitionBtn.OPEN_APPLY:
      return {
        label: '申し込む',
        type: ButtonType.Submit,
        fillType: FillType.primaryFill,
        buttonSize: ButtonSize.sizeM,
        onClick: cb,
      };
    case TransitionBtn.UPDATE_APPLY:
      return {
        label: '登録情報を更新する',
        type: ButtonType.Submit,
        fillType: FillType.primaryFill,
        buttonSize: ButtonSize.sizeM,
        onClick: cb,
      };
    case TransitionBtn.CONFIRM:
      return {
        label: '確認画面へ',
        type: ButtonType.Submit,
        fillType: FillType.primaryFill,
        buttonSize: ButtonSize.sizeM,
        onClick: cb,
      };
    case TransitionBtn.NEXT:
      return {
        label: '次へ',
        type: ButtonType.Submit,
        fillType: FillType.primaryFill,
        buttonSize: ButtonSize.sizeM,
        onClick: cb,
      };
    case TransitionBtn.PREV:
      return {
        label: '戻る',
        type: ButtonType.Button,
        fillType: FillType.primaryEmpty,
        buttonSize: ButtonSize.sizeM,
        onClick: cb,
      };
    case TransitionBtn.SEARCH_ADDRESS:
      return {
        label: '住所を検索',
        type: ButtonType.Button,
        fillType: FillType.primaryFill,
        buttonSize: ButtonSize.sizeS,
        onClick: cb,
      };
  }
};

//住所検索API
export const useGetAddressInfo = (postCode: string) => {
  const [addressInfo, getAddressInfo] = useGetAddressInfoQuery({
    variables: { postCode },
    requestPolicy: 'network-only',
    pause: true,
  });
  return {
    addressInfo,
    getAddressInfo,
  };
};

//銀行名取得API
export const useGetBrokerMaster = (brokerCode: string, branchCode: string) => {
  const [bankMaster, getBankMaster] = useGetBrokerMasterQuery({
    variables: { brokerCode, branchCode },
    requestPolicy: 'network-only',
    pause: true,
  });
  return {
    bankMaster,
    getBankMaster,
  };
};

//リロード制御
export const reloadHandler = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  const message = '入力内容がリセットされます。ページを離れますか？';
  e.returnValue = message;
};
